var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goup"},[_c('div',{staticClass:"btn",class:{ 'btn-disabled': _vm.activityInfo.activity_state == 3 }},[_vm._v(_vm._s(_vm.activityInfo.activity_state == 3 ? '活动已结束' : '教练暂不支持赠送小红花哦～'))]),_c('PrizeList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }